import Axios from 'axios';

class AdminService {
  impersonateStudentInQP(studentId) {
    return Axios.post(`/admin/student-impersonation/${studentId}/impersonation-token`);
  }

  getAllStudentsCount() {
    return Axios.get('/admin/all-students-count');
  }

  getFinancialDataSummary(year, month) {
    let url = '/admin/financial-data-summary';
    if (year && month) {
      url += `/${year}/${month}`;
    }
    return Axios.get(url);
  }

  getBanks() {
    return Axios.get('/admin/banks');
  }

  getBillingsPendingManualConfig(params) {
    return Axios.get('/admin/manual-contract-creation', { params });
  }

  getBillingPendingManualConfig(billingId) {
    return Axios.get(`/admin/manual-contract-creation/${billingId}`);
  }

  createInitialContract(data) {
    return Axios.put(`/admin/manual-contract-creation/${data.billing.id}`, data);
  }

  createBankAccount(
    accountHolderType, accountHolderId, accountAttrs, transferDays, dueDays, allowStudentChangeDueDay,
    additionalInfo,
  ) {
    const parsedAccountAttrs = {
      bank_code: accountAttrs.bank_code,
      agency_code: accountAttrs.agency_code,
      number: accountAttrs.number,
      digit: accountAttrs.digit,
      company_name: accountAttrs.company_name,
      company_document: accountAttrs.company_document,
      bank_account_type: accountAttrs.bank_account_type,
    };

    return Axios.post('/admin/bank_account', {
      account_holder_type: accountHolderType,
      account_holder_id: accountHolderId,
      account_attrs: parsedAccountAttrs,
      transfer_days: transferDays,
      due_days: dueDays,
      allow_student_change_due_day: allowStudentChangeDueDay,
      additional_info: additionalInfo,
    });
  }

  deactivateBankAccount(bankAccount) {
    return Axios.post(`/admin/bank_account/${bankAccount.id}/deactivate`);
  }

  getBillingStartRules() {
    return Axios.get('/admin/billing_start_rules');
  }

  getInstitutionRules(institutionId) {
    return Axios.get(`/admin/institution_rules/${institutionId}`);
  }

  getAdmissionRules(institutionId) {
    return Axios.get(`/admin/institutions/${institutionId}/admission-rules`);
  }

  createInstitutionRules(institutionId, rules) {
    return Axios.post('/admin/institution_rules', {
      institution_id: institutionId,
      rules,
    });
  }

  getIncomes() {
    return Axios.get('/admin/incomes');
  }

  createAdmissionRule(institutionId, rules) {
    return Axios.post(`/admin/institutions/${institutionId}/admission-configurations`, {
      rules,
    });
  }

  listModel(modelName, params) {
    return Axios.post('/admin/model_list', {
      model_name: modelName,
      ...params,
    });
  }

  getObject(modelName, objectId) {
    return Axios.post('/admin/model_retrieve', {
      model_name: modelName,
      id: objectId,
    });
  }

  resendApiEvent(objectsIds) {
    return Axios.post('/admin/api_events/redeliver', {
      api_event_ids: objectsIds,
    });
  }
}

export default new AdminService();
